<div class="modal-header border-bottom">
  <h4 class="modal-title fw-normal">Upload File(s)</h4>
</div>

<div class="modal-body">
  <div class="alert alert-success border-success d-flex px-2 py-3 align-items-center gap-2">
    <i class="bi bi-check-circle-fill"></i>
    <div class="text">File(s) uploaded successfully.</div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary fw-normal" (click)="onClose()">Close</button>
</div>
